import {useActions} from 'hooks'
import {useLocation} from 'react-router'
import {NavLink} from '../LeftNavLink'
import {CanIAccess, PERMISSIONS} from 'rbac'

export function SettingsLeftNavigation() {
  const location = useLocation()
  const {pathname} = location

  const {doIHaveAccess} = useActions()

  return (
    <div className="flex flex-col items-start pt-3 px-5">
      <CanIAccess reqPermissions={[PERMISSIONS.GENERAL_SETTINGS.READ]}>
        <NavLink
          pathname="/settings/general"
          first
          current={pathname === '/settings/general'}
          linkName="General"
          isVisible={doIHaveAccess}
        />
      </CanIAccess>
      <CanIAccess reqPermissions={[PERMISSIONS.BLOCK_PAGES.READ]}>
        <NavLink
          data-cy="blockpages"
          pathname="/settings/block-pages"
          first
          current={pathname === '/settings/block-pages'}
          linkName="Block Pages"
        />
      </CanIAccess>
      <CanIAccess reqPermissions={[PERMISSIONS.ENDPOINT_CONFIGURATION.READ]}>
        <NavLink
          pathname="/settings/endpoints"
          first
          current={pathname === '/settings/endpoints'}
          linkName="Endpoints"
        />
      </CanIAccess>
      <CanIAccess reqPermissions={[PERMISSIONS.USER_MANAGEMENT.READ]}>
        <NavLink
          data-cy="users"
          pathname="/settings/users"
          first
          current={pathname === '/settings/users'}
          linkName="Users"
        />
      </CanIAccess>
      <CanIAccess reqPermissions={[PERMISSIONS.AUDIT_LOG.READ]}>
        <NavLink
          pathname="/settings/audit-log"
          first
          current={pathname === '/settings/audit-log'}
          linkName="Audit Log"
        />
      </CanIAccess>
      <CanIAccess reqPermissions={[PERMISSIONS.ADD_S3_BUCKET_LOCATION.READ]}>
        <NavLink
          data-cy="settings-siem"
          pathname="/settings/siem"
          first
          current={pathname === '/settings/siem'}
          linkName="SIEM"
        />
      </CanIAccess>
      <CanIAccess reqPermissions={[PERMISSIONS.API_KEYS.READ]}>
        <NavLink
          data-cy="settings-api"
          pathname="/settings/api"
          first
          current={pathname === '/settings/api'}
          linkName="API"
        />
      </CanIAccess>
      <CanIAccess reqPermissions={[PERMISSIONS.BILLING_DETAILS.READ]}>
        <NavLink
          data-cy="billing"
          pathname="/settings/billing"
          first
          current={pathname === '/settings/billing'}
          linkName="Billing"
          isVisible={doIHaveAccess}
        />
      </CanIAccess>
    </div>
  )
}
